import { render, staticRenderFns } from "./IndicatorSelection.vue?vue&type=template&id=501f2d6e&scoped=true"
import script from "./IndicatorSelection.vue?vue&type=script&lang=js"
export * from "./IndicatorSelection.vue?vue&type=script&lang=js"
import style0 from "./IndicatorSelection.vue?vue&type=style&index=0&id=501f2d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f2d6e",
  null
  
)

export default component.exports